document.addEventListener("DOMContentLoaded", function () {

  /* ===============================
     Promotion Switch
  =============================== */

  const ENABLE_FREE_GIFT = false; 
  // true  = Free gift 模式
  // false = 纯 Upsell 模式


  /* ===============================
     基础工具函数
  =============================== */

  function getCart() {
    return fetch("/cart.js").then(res => res.json());
  }

  function refreshCartUI() {
    if (window.MinimogCart && typeof window.MinimogCart.refresh === "function") {
      window.MinimogCart.refresh();
    } else if (window.refreshCart && typeof window.refreshCart === "function") {
      window.refreshCart();
    } else {
      location.reload();
    }
  }

  function removeExistingUpsells() {
    getCart().then(cart => {

      document.querySelectorAll(".captify-incart-upsell-item").forEach(upsell => {

        const upsellHandle = upsell.dataset.productHandle;

        // 🔵 Free gift 模式才删除
        if (ENABLE_FREE_GIFT) {
          const handlesInCart = cart.items.map(item => item.product_handle);
          if (handlesInCart.includes(upsellHandle)) {
            upsell.remove();
          }
        }

      });

      document.querySelectorAll(".captify-incart-upsell").forEach(wrapper => {
        const grid = wrapper.querySelector(".captify-incart-upsell-grid");
        if (!grid || grid.children.length === 0) {
          wrapper.remove();
        }
      });

    });
  }

  function addVariantOnce(variantId) {
    return getCart().then(cart => {

      // Free gift 模式：防止重复
      if (ENABLE_FREE_GIFT) {
        const exists = cart.items.some(item => item.variant_id == variantId);
        if (exists) return Promise.resolve("already-in-cart");
      }

      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(res => res.json());
    });
  }


  /* ===============================
     删除赠品（仅 Free Gift 模式）
  =============================== */

  function removeProGiftIfNoPro() {
    if (!ENABLE_FREE_GIFT) return;

    getCart().then(cart => {

      const hasPro = cart.items.some(item => item.product_id == 9074423726312);
      if (hasPro) return;

      const proGift = cart.items.find(item => item.product_id == 9104776888552);
      if (!proGift) return;

      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: proGift.key,
          quantity: 0
        })
      }).then(() => {
        refreshCartUI();
      });

    });
  }


  /* ===============================
     Upsell：手动点击
  =============================== */

  function bindUpsellButtons() {
    document.querySelectorAll(".captify-incart-upsell-btn").forEach(button => {

      if (button.dataset.bound === "true") return;
      button.dataset.bound = "true";

      button.addEventListener("click", function (e) {
        e.preventDefault();

        const upsellItem = button.closest(".captify-incart-upsell-item");
        if (!upsellItem) return;

        const select = upsellItem.querySelector("select");
        if (!select) return;

        const variantId = select.value;

        addVariantOnce(variantId).then(() => {

          // 🔵 Free gift 模式才删除
          if (ENABLE_FREE_GIFT) {

            upsellItem.remove();

            const grid = document.querySelector(".captify-incart-upsell-grid");
            if (grid && grid.children.length === 0) {
              const wrapper = grid.closest(".captify-incart-upsell");
              if (wrapper) wrapper.remove();
            }

          }

          refreshCartUI();
          removeExistingUpsells();

        });

      });

    });
  }


  /* ===============================
     Free Gift 自动加赠
  =============================== */

  function autoAddFreeGiftsOnce() {
    if (!ENABLE_FREE_GIFT) return;

    getCart().then(cart => {

      const hasPro = cart.items.some(item => item.product_id == 9074423726312);
      if (!hasPro) return;

      document
        .querySelectorAll('.captify-incart-upsell-item[data-parent-product="captify-pro"]')
        .forEach(item => {

          if (item.dataset.freeGiftAdded === "true") return;

          const select = item.querySelector("select");
          if (!select) return;

          item.dataset.freeGiftAdded = "true";

          const variantId = select.value;

          addVariantOnce(variantId).then(() => {

            item.remove();
            refreshCartUI();
            removeExistingUpsells();

          });

        });

    });
  }


  /* ===============================
     初始化
  =============================== */

  removeExistingUpsells();
  bindUpsellButtons();

  if (ENABLE_FREE_GIFT) {
    setTimeout(autoAddFreeGiftsOnce, 500);
  }

  document.addEventListener("cart:updated", function () {

    removeExistingUpsells();
    bindUpsellButtons();

    if (ENABLE_FREE_GIFT) {
      removeProGiftIfNoPro();
      setTimeout(autoAddFreeGiftsOnce, 500);
    }

  });

});